import React, { useEffect, useRef, useState } from 'react'
import { fetchAiCallDetailsApi, updateAiCallApi } from '../../../../../redux/slices/aicalls/aicallsApi';
import { Backdrop, Button, LogoLoader } from '../../../../../components';

const AiCallSummaryModel = ({call}) => {
  const audioRef = useRef(null);

  const [aiCallDetails, setAiCallDetails] = useState();
  const [loading, setLoading] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const hasAudio = !!aiCallDetails?.artifact?.stereoRecordingUrl;
  const hasSummary = !!aiCallDetails?.summary;
  const hasTranscript =
    typeof aiCallDetails?.transcript === "string" &&
    aiCallDetails.transcript.trim().length > 0;

  const handleToggleAudio = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      audio.currentTime = 0;
      setIsPlaying(false);
    } else {
      audio.play();
      setIsPlaying(true);
    }
  };

  const handleDownload = async () => {
    const url = aiCallDetails?.artifact?.stereoRecordingUrl;
    try {
      setLoading(true);
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `audio-${Date.now()}.wav`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAiCallDetails = async () => {
    try {
      setLoading(true);
      if (!call || !call?.callId || !call?.integrationId) {
        return;
      }
      const response = await fetchAiCallDetailsApi({callId: call?.callId, integrationId: call?.integrationId});

      if (response?.success) {
        setAiCallDetails(response?.data?.data);

        if (response?.data?.data?.endedReason !== call?.endedReason) {
          const updateEndedReason = await updateAiCallApi({
            coll: "AiCall", 
            uiid: call?.uiid,
            payload: [{
              type: "SET", 
              value: {endedReason: response?.data?.data?.endedReason}
            }]
          });
        }
      }
    } catch(error) {
      console.error("Error fetching ai call details: ", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAiCallDetails();
  }, [call]);

  return (
    <>
      {!loading && (!aiCallDetails ? (
        <span>Ai Call Details Not Found</span>
      ) : (
        <div className='flex flex-col gap-3'>
          <div className='flex gap-5'>
            <p><span className='font-semibold me-1'>Mobile Number: </span>{aiCallDetails?.customer?.number}</p>
            <p><span className='font-semibold me-1'>Ended Reason: </span>{aiCallDetails?.endedReason}</p>
          </div>
          {hasSummary && (
            <>
              <span className='font-semibold'>Summary:</span>
              <div className='bg-gray-50 border border-gray-200 p-3 rounded-md'>
                {aiCallDetails?.summary}
              </div>
            </>
          )}
          {hasTranscript && (
            <>
              <div className='flex justify-between'>
                <span className='font-semibold'>Transcript:</span>
                {hasAudio && (
                  <div className='flex gap-3'>
                    <Button 
                      title={isPlaying ? "Stop audio" : "Click to listen audio"}                    
                      variant='outlined'
                      size='sm'
                      onClick={() => handleToggleAudio()}
                    />
                    <Button
                      type='icon'
                      icon={"download"}
                      variant='text'
                      color='black'
                      onClick={() => {handleDownload()}}
                    />
                  </div>    
                )}                    
              </div>
              <div className='bg-gray-50 border border-gray-200 p-3 rounded-md'>
                {aiCallDetails?.transcript?.split("\n").map((line, index) => (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                ))}
              </div>
            </>
          )}  
          
        </div>
      ))}

      {hasAudio && (
        <audio
          ref={audioRef}
          src={aiCallDetails?.artifact?.stereoRecordingUrl}
        />
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </>
  )
}

export default AiCallSummaryModel;